import { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import axios from 'axios';

interface Props {
  action: 'reboot' | 'shutdown';
}

export function PowerOverlay({ action }: Props) {
  const [online, setOnline] = useState(false);

  useEffect(() => {
    if (action !== 'reboot') return;
    const id = setInterval(async () => {
      try {
        await axios.get('/api/health', { timeout: 3_000 });
        setOnline(true);
        clearInterval(id);
      } catch {
        // still offline
      }
    }, 5_000);
    return () => clearInterval(id);
  }, [action]);

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
      }}
    >
      {!online ? (
        <>
          {action === 'reboot' ? (
            <CircularProgress size={72} color="primary" />
          ) : (
            <PowerSettingsNewIcon sx={{ fontSize: 72, color: 'error.main' }} />
          )}
          <Typography variant="h5">
            {action === 'reboot' ? 'Server is rebooting…' : 'Server is shutting down…'}
          </Typography>
          <Typography color="text.secondary">
            {action === 'reboot'
              ? 'The page will offer a reload button when the server is back online.'
              : 'The server has been shut down. Manual power-on required.'}
          </Typography>
        </>
      ) : (
        <>
          <CheckCircleIcon sx={{ fontSize: 72, color: 'success.main' }} />
          <Typography variant="h5">Server is back online</Typography>
          <Button variant="contained" size="large" onClick={() => window.location.reload()}>
            Reload Page
          </Button>
        </>
      )}
    </Box>
  );
}
